<script>    
    import TeacherFinderComponent from "./TeacherFinderComponent.svelte";
    import TeacherAvailabilityCapacityComponent from "./TeacherAvailabilityCapacityComponent.svelte";
    import RefreshDatabaseButtonComponent from "./RefreshDatabaseButtonComponent.svelte";
    import FindStudentsComments from "./FindStudentsComments.svelte";
    import AdminCreateUserComponent from "./AdminCreateUserComponent.svelte";
    import StudentPricingModifierComponent from "./StudentPricingModifierComponent.svelte";
    import TeacherPricingModifierComponent from "./TeacherPricingModifierComponent.svelte";
    import AdminManualPaymentComponent from "./AdminManualPaymentComponent.svelte";
    import BalanceTransactionsCsvDownloader from "./BalanceTransactionsCsvDownloader.svelte";
    import TeacherRevenuePaymentCsvDownloader from "./TeacherRevenuePaymentCsvDownloader.svelte";
    import AdminFamilyManagerComponent from "./AdminFamilyManagerComponent.svelte";
    import NavBarReusable from "./NavbarReusable.svelte";
    import AdminDashboardLauncher from './AdminDashboardLauncher.svelte';
    import AdminAgreements from './AdminAgreements.svelte';
    import { onMount } from 'svelte';

    // State for tab management
    let activeTab = 'create-users'; // 'create-users', 'find-teachers', 'student-comments', 'student-pricing', 'teacher-pricing', 'manual-payments', 'balance-csv', 'teacher-revenue-csv', 'system-maintenance', 'invoice-debug', 'schedule-debug', 'user-invoice-view', 'families'
    let deepLinkTeacherId = null;

    function switchTab(tab) {
        activeTab = tab;
    }

    function getHashParts() {
        const hash = window.location.hash || '#/admin';
        const qIndex = hash.indexOf('?');
        if (qIndex === -1) return { path: hash, params: new URLSearchParams() };
        return { path: hash.slice(0, qIndex), params: new URLSearchParams(hash.slice(qIndex + 1)) };
    }

    function readTabFromHash() {
        const { path, params } = getHashParts();
        if (!path.startsWith('#/admin')) return;
        const tab = params.get('tab');
        const teacherId = params.get('teacherId');
        if (tab && tab !== 'activity-dashboard') activeTab = tab;
        deepLinkTeacherId = teacherId ? parseInt(teacherId, 10) : null;
    }

    onMount(() => {
        readTabFromHash();
        const onHashChange = () => readTabFromHash();
        window.addEventListener('hashchange', onHashChange);
        return () => window.removeEventListener('hashchange', onHashChange);
    });
</script>

<NavBarReusable label="Admin - User Management" />

<div class="tab-navigation">
    <button class="tab-button {activeTab === 'agreements' ? 'active' : ''}" on:click={() => switchTab('agreements')}>Dokumentai pasirašymui</button>
    <button class="tab-button {activeTab === 'monthly-feedback' ? 'active' : ''}" on:click={() => switchTab('monthly-feedback')}>Monthly email review</button>
    <a
        class="tab-button dashboard-link"
        href="#/admin/activity-dashboard"
        target="_blank"
        rel="noopener noreferrer"
    >
        📊 Activity Dashboard
        <span aria-hidden="true">↗</span>
    </a>
    <button 
        class="tab-button {activeTab === 'create-users' ? 'active' : ''}"
        on:click={() => switchTab('create-users')}
    >
        Create Users
    </button>
    <button 
        class="tab-button {activeTab === 'find-teachers' ? 'active' : ''}"
        on:click={() => switchTab('find-teachers')}
    >
        Find Teachers
    </button>
    <button
        class="tab-button {activeTab === 'teacher-capacity' ? 'active' : ''}"
        on:click={() => switchTab('teacher-capacity')}
    >
        Availability Capacity
    </button>
    <button 
        class="tab-button {activeTab === 'student-comments' ? 'active' : ''}"
        on:click={() => switchTab('student-comments')}
    >
        Student Comments
    </button>
    <button 
        class="tab-button {activeTab === 'student-pricing' ? 'active' : ''}"
        on:click={() => switchTab('student-pricing')}
    >
        Student Pricing
    </button>
    <button 
        class="tab-button {activeTab === 'teacher-pricing' ? 'active' : ''}"
        on:click={() => switchTab('teacher-pricing')}
    >
        Teacher Pricing
    </button>
    <button 
        class="tab-button {activeTab === 'manual-payments' ? 'active' : ''}"
        on:click={() => switchTab('manual-payments')}
    >
        Manual Payments
    </button>
    <button 
        class="tab-button {activeTab === 'families' ? 'active' : ''}"
        on:click={() => switchTab('families')}
    >
        👪 Families
    </button>
    <button 
        class="tab-button {activeTab === 'balance-csv' ? 'active' : ''}"
        on:click={() => switchTab('balance-csv')}
    >
        📥 Balance CSV
    </button>
    <button 
        class="tab-button {activeTab === 'teacher-revenue-csv' ? 'active' : ''}"
        on:click={() => switchTab('teacher-revenue-csv')}
    >
        💰 Teacher Revenue CSV
    </button>
    <button 
        class="tab-button {activeTab === 'system-maintenance' ? 'active' : ''}"
        on:click={() => switchTab('system-maintenance')}
    >
        Database refresh
    </button>
    <button 
        class="tab-button {activeTab === 'invoice-debug' ? 'active' : ''}"
        on:click={() => switchTab('invoice-debug')}
    >
        Invoice Debug
    </button>
    <button 
        class="tab-button {activeTab === 'schedule-debug' ? 'active' : ''}"
        on:click={() => switchTab('schedule-debug')}
    >
        Schedule Debug
    </button>
    <button 
        class="tab-button {activeTab === 'user-invoice-view' ? 'active' : ''}"
        on:click={() => switchTab('user-invoice-view')}
    >
        👁️ User Invoice View
    </button>
</div>

{#if activeTab === 'agreements'}
    <div class="classcontainer"><AdminAgreements /></div>
{:else if activeTab === 'monthly-feedback'}
    <AdminDashboardLauncher
        title="Monthly email review"
        href="#/admin/monthly-feedback"
        description="Review each family's frozen teacher feedback email, hold anything that needs attention, then send eligible emails from the full review page."
        launchLabel="Launch Monthly email review"
        on:close={() => switchTab('create-users')}
    />
{:else if activeTab === 'create-users'}
    <div class="classcontainer">
        <h3>Create New Student Account</h3>
        <AdminCreateUserComponent />
    </div>
{:else if activeTab === 'find-teachers'}
    <div class="classcontainer">
        <h3>Find Teachers</h3>
        <TeacherFinderComponent />
    </div>
{:else if activeTab === 'teacher-capacity'}
    <div class="classcontainer">
        <TeacherAvailabilityCapacityComponent />
    </div>
{:else if activeTab === 'student-comments'}
    <div class="classcontainer">
        <h3>Find Student Comments</h3>
        <FindStudentsComments />
    </div>
{:else if activeTab === 'student-pricing'}
    <div class="classcontainer">
        <h3>Student Pricing Modifiers</h3>
        <StudentPricingModifierComponent />
    </div>
{:else if activeTab === 'teacher-pricing'}
    <div class="classcontainer">
        <h3>Teacher Pricing Modifiers</h3>
        <TeacherPricingModifierComponent embedded={!!deepLinkTeacherId} teacherId={deepLinkTeacherId} />
    </div>
{:else if activeTab === 'manual-payments'}
    <div class="classcontainer">
        <h3>Manual Payment Transactions</h3>
        <AdminManualPaymentComponent />
    </div>
{:else if activeTab === 'families'}
    <div class="classcontainer">
        <h3>Family Connections</h3>
        <AdminFamilyManagerComponent />
    </div>
{:else if activeTab === 'balance-csv'}
    <BalanceTransactionsCsvDownloader />
{:else if activeTab === 'teacher-revenue-csv'}
    <TeacherRevenuePaymentCsvDownloader />
{:else if activeTab === 'system-maintenance'}
    <div class="classcontainer">
        <h3>Database refresh</h3>
        <RefreshDatabaseButtonComponent />
    </div>
{:else if activeTab === 'invoice-debug'}
    <div class="classcontainer">
        <h3>🔧 Student Invoice Debug Tool</h3>
        <p style="margin-bottom: 1rem; color: #666;">
            This tool allows you to view any student's invoice page exactly as they see it, 
            including balance calculations and validation details.
        </p>
        <div style="text-align: center; margin: 2rem 0;">
            <a href="#/admin/student-invoice-debug" style="
                display: inline-block;
                padding: 12px 24px;
                background-color: #dc3545;
                color: white;
                text-decoration: none;
                border-radius: 8px;
                font-weight: bold;
                font-size: 1.1rem;
                transition: background-color 0.3s ease;
            ">
                🔧 Launch Invoice Debug Tool
            </a>
        </div>
        <div style="font-size: 0.9rem; color: #666; margin-top: 1rem;">
            <strong>Features:</strong>
            <ul style="margin: 0.5rem 0; padding-left: 2rem;">
                <li>Select any student from a dropdown</li>
                <li>View their exact invoice page (identical to student view)</li>
                <li>See validation details for balance calculations</li>
                <li>Generate test invoices (payment disabled)</li>
                <li>Debug balance transaction validation</li>
            </ul>
        </div>
    </div>
{:else if activeTab === 'schedule-debug'}
    <div class="classcontainer">
        <h3>📅 Student Schedule Debug Tool</h3>
        <p style="margin-bottom: 1rem; color: #666;">
            This tool allows you to view any student's schedule page exactly as they see it, 
            including past/upcoming classes, filters, and interactive elements.
        </p>
        <div style="text-align: center; margin: 2rem 0;">
            <a href="#/admin/student-schedule-debug" style="
                display: inline-block;
                padding: 12px 24px;
                background-color: #dc3545;
                color: white;
                text-decoration: none;
                border-radius: 8px;
                font-weight: bold;
                font-size: 1.1rem;
                transition: background-color 0.3s ease;
            ">
                📅 Launch Schedule Debug Tool
            </a>
        </div>
        <div style="font-size: 0.9rem; color: #666; margin-top: 1rem;">
            <strong>Features:</strong>
            <ul style="margin: 0.5rem 0; padding-left: 2rem;">
                <li>Select any student from a dropdown</li>
                <li>View their exact schedule page (identical to student view)</li>
                <li>See all class filters (past, upcoming, cancelled)</li>
                <li>Debug class status and timing logic</li>
                <li>View reschedule requests and registration requests</li>
                <li>Interactive elements disabled for safety</li>
            </ul>
        </div>
    </div>
{:else if activeTab === 'user-invoice-view'}
    <div class="classcontainer">
        <h3>👁️ User Invoice Page View</h3>
        <p style="margin-bottom: 1rem; color: #666;">
            View the <strong>exact</strong> invoice page that users see - perfect for debugging user-reported issues. 
            This is a pure replica without any debug features, showing exactly what appears in the user's view.
        </p>
        <div style="text-align: center; margin: 2rem 0;">
            <a href="#/admin/user-invoice-view" style="
                display: inline-block;
                padding: 12px 24px;
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                color: white;
                text-decoration: none;
                border-radius: 8px;
                font-weight: bold;
                font-size: 1.1rem;
                transition: all 0.3s ease;
                box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
            ">
                👁️ Launch User Invoice View
            </a>
        </div>
        <div style="font-size: 0.9rem; color: #666; margin-top: 1rem;">
            <strong>Features:</strong>
            <ul style="margin: 0.5rem 0; padding-left: 2rem;">
                <li>Select any user from a dropdown</li>
                <li>See their <strong>exact</strong> invoice page (pure user view, no debug features)</li>
                <li>Test invoice generation exactly as users experience it</li>
                <li>View their balance, classes, and payment history</li>
                <li>Payment functionality disabled for safety</li>
                <li>Perfect for reproducing user-reported issues</li>
            </ul>
        </div>
        <div style="margin-top: 1.5rem; padding: 1rem; background-color: #e7f3ff; border-left: 4px solid #667eea; border-radius: 4px;">
            <strong style="color: #004085;">💡 Use Case:</strong>
            <p style="color: #004085; margin: 0.5rem 0 0 0; font-size: 0.9rem;">
                When users report issues with their invoice page (e.g., "classes not showing", "balance is wrong", "can't generate invoice"), 
                use this tool to see exactly what they're experiencing. Unlike the Invoice Debug tool, this has no extra features - 
                it's the pure user experience for accurate debugging.
            </p>
        </div>
    </div>
{/if}

<style>
    .tab-navigation {
        display: flex;
        gap: 10px;
        margin-bottom: 20px;
        flex-wrap: wrap;
    }

    .tab-button {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 10px 20px;
        border: 1px solid #ccc;
        background: white;
        cursor: pointer;
        border-radius: 8px;
        font-size: 14px;
        color: #222;
        text-decoration: none;
    }

    .dashboard-link {
        background: #0c131d;
        border-color: #1b8d68;
        color: #dce7f3;
    }

    .tab-button.active {
        background: #fab45a;
        color: black;
        border-color: #fab45a;
    }

    .classcontainer {
        padding: 15px;
        background-color: white;
        display: flex;
        flex-direction: column;
        margin-bottom: 15px;
        gap: 10px;
        box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16);
        border-radius: 8px;
        flex: none;
        color: black;
        align-items: flex-start;
    }

    .classcontainer h3 {
        margin: 0 0 15px 0;
        color: #333;
    }

    /* Override nested component styles for cleaner integration */
    :global(.classcontainer .admin-create-user) {
        max-width: none;
        margin: 0;
        padding: 0;
    }

    :global(.classcontainer .teacher-finder) {
        max-width: none;
        margin: 0;
        padding: 0;
    }

    :global(.classcontainer .find-students-comments) {
        max-width: none;
        margin: 0;
        padding: 0;
    }

    :global(.classcontainer .refresh-database) {
        max-width: none;
        margin: 0;
        padding: 0;
    }

    :global(.classcontainer .manual-payment-container) {
        max-width: none;
        margin: 0;
        padding: 0;
        box-shadow: none;
    }

    :global(.classcontainer .pricing-modifier-container) {
        max-width: none;
        margin: 0;
        padding: 0;
        box-shadow: none;
    }

    :global(.classcontainer .family-manager) {
        max-width: none;
        margin: 0;
        padding: 0;
        box-shadow: none;
    }
</style>
